import { StandardEvents } from '@shopify/events';

let generation = 0;
let refreshTimer;
let controller;

// Keep recommendations outside the updated cart without calculating rewards.
async function refreshSuggestions(requestGeneration) {
    if (requestGeneration !== generation) return;
    if (!document.querySelector('[data-bundle-suggestion], [data-frest-cart-suggestion]')) return;
    controller = new AbortController();
    try {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin', cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (requestGeneration !== generation || !Array.isArray(cart.items)) return;
        const cartIsEmpty = cart.items.length === 0;
        const productIds = new Set(cart.items.map(item => String(item.product_id ?? item.product?.id ?? '')));
        for (const item of document.querySelectorAll('[data-bundle-suggestion], [data-frest-cart-suggestion]')) {
            item.hidden = productIds.has(item.dataset.productId);
        }
        // Cart items hydrate independently from the separate cart recommendation section.
        // Hide its heading and cards after the last item is removed, while PDP art remains usable.
        for (const group of document.querySelectorAll('[data-frest-cart-recommendations]')) {
            const section = group.closest('.shopify-section') ?? group;
            const hasVisibleSuggestions = [...group.querySelectorAll('[data-frest-cart-suggestion]')]
                .some(item => !item.hidden);
            const hidden = cartIsEmpty || !hasVisibleSuggestions;
            section.hidden = hidden;
            section.classList.toggle('hidden', hidden);
        }
        for (const group of document.querySelectorAll('.frest-bundle__suggestions')) {
            group.hidden = ![...group.querySelectorAll('[data-bundle-suggestion]')].some(item => !item.hidden);
        }
    } catch {
        // Retain Shopify-rendered suggestions when the cart cannot be read.
    }
}

function invalidateRefresh() {
    ++generation;
    clearTimeout(refreshTimer);
    controller?.abort();
}

async function queueRefresh(event) {
    invalidateRefresh();
    const requestGeneration = generation;
    try { await (event?.promise ?? event?.detail?.promise); }
    catch { return; }
    if (requestGeneration === generation) {
        refreshTimer = setTimeout(() => refreshSuggestions(requestGeneration), 120);
    }
}

document.addEventListener(StandardEvents.cartLinesUpdate, queueRefresh);
document.addEventListener(StandardEvents.cartDiscountUpdate, queueRefresh);
document.addEventListener(StandardEvents.cartError, invalidateRefresh);
document.addEventListener('quantity-selector:update', invalidateRefresh);
window.addEventListener('pagehide', invalidateRefresh);
window.addEventListener('pageshow', event => { if (event.persisted) queueRefresh(); });
document.addEventListener('visibilitychange', () => { if (!document.hidden) queueRefresh(); });
